module.exports = __webpack_public_path__ + "img/gb9877_1-88-10x22x7.prt.32cad697.jpg";